// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {formatText} from 'common/util/format-text';

import {CellRenderContext, TableRow} from './types';

export const FieldWithMatches = ({
  context,
  shouldFormatText,
}: {
  item?: TableRow;
  context: CellRenderContext;
  shouldFormatText?: boolean;
}) => (
  <div>
    {context.matchParts ? (
      context.matchParts.map((part) => <span sel='.mp-table-cell-match-part'>{part}</span>)
    ) : (
      <div sel='.mp-table-cell-label'>{shouldFormatText ? formatText(context.label) : context.label}</div>
    )}
  </div>
);

export const getLinkCellRenderer =
  (attrTransform: (TableRow) => any = () => ({})) =>
  (row: TableRow, context: CellRenderContext) => (
    <a attrs={Object.assign({href: context.label}, attrTransform(row))}>{context.label}</a>
  );
